import { deepMerge } from "src/helpers";
import { DefaultTheme } from "styled-components";

export const APP_THEME: DefaultTheme = {
  viewHeight: "100vh",
  alertBox: {
    boxShadow:
      "inset 0 1px 0 rgba(255, 255, 255, 0.5), inset 0 -1px 0 rgba(0, 0, 0, 0.025), 0 0 4px rgba(0, 0, 0, 0.2);",
    colors: {
      accent: "rgba(147, 50, 142, 0.3)",
      danger: "#dc3309",
      disabled: "rgb(220,220,220)",
      info: "hsl(209, 100%, 42%)",
      light: "#fafafa",
      primary: "#832a8f",
      primaryLight: "#93328e",
      primaryReadable: "rgb(147, 50, 142, .2)",
      shadow: "rgba(0, 0, 0, 0.5)",
      success: "hsla(159, 97%, 27%, 1)",
      warning: "#ff9a1f",
      filePicker: "rgb(249, 249, 249)",
      white: "#ffffff",
      tableStrip: "rgb(249, 249, 249)",
    },
    opacity: "0.15",
    zIndex: "unset",
    alignItems: "center",
  },
  colors: {
    background: {
      accent: "rgba(147, 50, 142, 0.3)",
      danger: "#dc3309",
      disabled: "rgb(220,220,220)",
      info: "hsl(209, 100%, 42%)",
      light: "#fafafa",
      primary: "#832a8f",
      primaryLight: "#93328e",
      primaryReadable: "rgb(147, 50, 142, .2)",
      shadow: "rgba(0, 0, 0, 0.5)",
      success: "hsla(159, 97%, 27%, 1)",
      warning: "#ff9a1f",
      filePicker: "rgb(249, 249, 249)",
      white: "#ffffff",
      tableStrip: "rgb(249, 249, 249)",
    },
    message: {
      primary: "#93328e",
      danger: "#dc3309",
    },
    text: {
      primary: "#832a8f",
      danger: "#dc3309",
      warning: "#ff9a1f",
      disabled: "rgb(157,157,157)",
      placeholder: "rgb(130,146,176)",
      accent: "rgb(31,36,42)",
      readable: "rgb(27,40,66)",
      soft: "rgb(36,54,88)",
      link: "#832a8f",
      light: "#6c757d",
      white: "#fff",
      success: "rgba(0, 170, 19, 1)",
    },
    borders: {
      brand: "#832a8f",
      light: "#e0e0e0",
      active: "rgb(155,167,191)",
      appBar: "rgb(232,232,232)",
      cardBorder: "rgb(207, 211, 220)",
      filePicker: "rgb(249, 249, 249)",
      stepper: "rgb(231, 231, 231)",
    },
    gradients: {
      backdrop:
        "linear-gradient(-180deg, rgba(0, 0, 0, 0.35) 0%, rgba(0, 0, 0, 0.7) 100%);",
    },
    boxShadow: {
      dropdown: "0px 0px 10px 0px hsla(222, 42%, 6%, 0.1)",
    },
  },
  text: {
    fontFamily: {
      demi: "MaisonNeueDemi,sans-serif",
      normal: "MaisonNeue,sans-serif",
      book: "MaisonNeueBook,sans-serif",
      bold: "MaisonNeueBold,sans-serif",
    },
    lineHeight: {
      normal: "22px",
      large: "25px",
      xsmall: "14px",
    },
    size: {
      xsmall: "10px",
      small: "12px",
      medium: "14px",
      normal: "16px",
      large: "18px",
      mlarge: "21px",
      xlarge: "24px",
      xxlarge: "26px",
    },
  },
  layout: {
    zIndex: {
      modal: 10000051,
      dropdown: 10000050,
      toast: 10000100,
      filePickerTooltip: 2,
      mobileHeader: 1,
    },
    margin: {
      xs: 4,
      s: 8,
      m: 12,
      l: 16,
      xl: 24,
      xxl: 32,
    },
    width: {
      modal: 704,
      languageSwitcherPopover: 184,
    },
    height: {
      mobileHeader: 59,
    },
  },
  dimension: {
    borderRadius: [2, 4, 8],
    spacing: {
      xs: 4,
      s: 8,
      m: 12,
      l: 16,
      xl: 24,
      xxl: 32,
      xxxl: 48,
    },
    width: {
      modal: 704,
      modalSlim: 440,
      smallContainer: 464,
      button: 144,
      buttonLong: 180,
      languageSwitcherPopover: 184,
      stepper: 288,
    },
  },
  animations: {
    spin: "spin 1.5s linear infinite",
  },
  components: {
    input: {
      labelFontSize: "small",
    },
    combobox: {
      optionHeight: 40,
    },
  },
};

export const MIDTRANS_APP_THEME: DefaultTheme = deepMerge(APP_THEME, {
  alertBox: {
    boxShadow: "unset",
    colors: {
      accent: "#fff",
      danger: "#fff",
      disabled: "#000",
      info: "#fff",
      light: "#000",
      primary: "#fff",
      success: "#fff",
      warning: "#fff",
      white: "#000",
    },
    opacity: "unset",
    zIndex: "-1",
    alignItems: "flex-start",
  },
  colors: {
    background: {
      accent: "#002855",
      danger: "#dc3309",
      disabled: "rgb(242,242,242)",
      info: "hsl(209, 100%, 42%)",
      primary: "#0256a6",
      primaryLight: "#9DDCF9",
      filePicker: "#F3F7FB",
    },
    message: {
      primary: "rgb(230, 240, 250)",
      danger: "rgb(251, 235, 230)",
    },
    text: {
      primary: "#0256a6",
    },
    borders: {
      brand: "#0256A7",
      light: "#e0e0e0",
      active: "rgb(155,167,191)",
      appBar: "rgb(230,233,239)",
      cardBorder: "rgb(207, 211, 220)",
      filePicker: "#F3F7FB",
    },
    gradients: {
      backdrop:
        "linear-gradient(-180deg, rgba(0, 0, 0, 0.35) 0%, rgba(0, 0, 0, 0.7) 100%);",
    },
  },
  text: {
    fontFamily: {
      book: "Poppins-Regular,sans-serif",
      normal: "Poppins-Regular,sans-serif",
      demi: "Poppins-SemiBold,sans-serif",
      bold: "Poppins-SemiBold,sans-serif",
    },
  },
  components: {
    input: {
      labelFontSize: "normal",
    },
  },
});
